export default __webpack_public_path__ + "static/media/bg-bobike.94912a27.png";